<template>
    <Row type="none">
        <BreadcrumbRow :items="breadcrumbItems"/>
        <GoBackButtonRow/>

        <MarginTop/>

        <Modal
            :text="modalText"
            id="modal_show"
        />

        <FormTag>
            <!--   Select product   -->
            <div class="d-flex">
                <div class="mr-2">
                    {{ $t('product.choose') }}
                </div>
                <div>
                    |
                </div>
                <div class="ml-2">
                    {{ $t('product.barcode') }}
                </div>
            </div>

            <Row type="form-row">
                <div class="col-sm-8">
                    <v-select
                        :options="getProducts"
                        label="name"
                        :reduce="options => options"
                        v-model="selectedProduct"
                        :taggable="true"
                        @close="selectFoundProduct"
                        @input="inSelectedProduct"
                    >
                        <template #no-options="{}">
                            {{ $t("selectError") }}
                        </template>

                        <template #search="{ attributes, events }">
                            <input
                                v-model="productBarCode"
                                class="vs__search"
                                v-bind="attributes"
                                v-on="events"
                                @input="(value) => {searchProductByBarCode(value)}"
                                ref="search"
                            />
                        </template>

                    </v-select>
                </div>
                <Column
                    sm-size="2"
                >
                    <ButtonTag :url="'products/add'" :is-w100="true">
                        <TextTag :xs-display="false" :sm-display="true">
                            &plus; {{ $t('new') }}
                        </TextTag>
                        <TextTag :sm-display="false">
                            {{ $t('product.add') }}
                        </TextTag>
                    </ButtonTag>
                </Column>
            </Row>
            <!--            Select product    -->

            <SelectBoxAndAddButton
                label="supplier.choose"
                fetch-name="fetchSuppliers"
                getter-name="getSuppliers"
                model-name="supplierId"
                text-field="text"
                url-to-add="suppliers/add"
                add-text="supplier.add"
                :after-fetch="afterFetchSupplier"
                :errors="errors"
                :model-form="modelForm"
            />

            <!--Selected Warehouses-->
            <div class="">
                {{ $t('warehouse.choose') }}
            </div>
            <Row type="form-row">

                <v-select
                    class="col-sm-8"
                    :options="getWarehouses"
                    label="name"
                    :reduce="options => options.id"
                    v-model="modelForm.warehouseId"
                >
                    <template #no-options="{}">
                        {{ $t("selectError") }}
                    </template>
                </v-select>
                <Column
                    sm-size="2"
                >
                    <ButtonTag :url="'warehouses/add'" :is-w100="true">
                        <TextTag :xs-display="false" :sm-display="true">
                            &plus; {{ $t('new') }}
                        </TextTag>
                        <TextTag :sm-display="false">
                            {{ $t('warehouse.add') }}
                        </TextTag>
                    </ButtonTag>
                </Column>
            </Row>
            <span v-if="!this.hasAdditionalUnitOfMeasure">
                <Amount :errors="errors" :model-form="modelForm"/>
            </span>
            <Row
                v-else
                type="form-row"
                class="col-sm-10 m-0 pt-2 mb-2 pl-2"
            >
                <div class="col-12 d-sm-inline mt-2">
                    <Row v-for="(exp, index) in quantityCalculation"
                         :key="index">
                        <div class="col-4 col-sm-5 d-sm-inline p-0 pr-sm-1 pr-2">
                            <span>{{ $t('amount') }}</span>
                            <input
                                class="form-control d-inline"
                                type="number"
                                min="0"
                                @input="calculateAmount()"
                                v-model="exp.amountUnitOfMeasures"
                            />
                        </div>
                        <div class="col-5 col-sm-5 d-sm-inline p-0 mr-0 pl-2 pb-2 pb-sm-3">
                            <span>{{ $t('unitOfMeasure.short') }}</span>
                            <v-select
                                :options="additionalUnitOfMeasure"
                                label="name"
                                :reduce="options => options"
                                v-model="exp.unitOfMeasures"
                                @input="calculateAmount()"
                            >
                                <template v-if="exp.unitOfMeasures">
                                    {{ $t("selectError") }}
                                </template>
                            </v-select>
                        </div>
                        <div class="col-1 col-sm-1 text-right d-inline ml-1 ml-sm-0 p-0 pt-4">
                            <IconButton
                                class="mt-1"
                                icon="plus"
                                title="purchase"
                                :do-action="moreAmount"
                            />
                        </div>
                        <div
                            v-if="index"
                            class="col-1 col-sm-1 d-inline text-left text-sm-center text-primary p-0 pr-sm-1 pl-1 pt-3"
                            @click="deleteOne(index)"
                        >
                            <h2 class="mt-1">&times;</h2>

                        </div>
                    </Row>
                </div>
            </Row>
            <PricePerUnit
                :errors="errors"
                :model-form="modelForm"
                :input="changeInput"
                priceLabel="purchasePerUnit"
                :priceLabel2="'(' + unit() + ')'"
            />
            <Row v-if="modelForm.pricePerUnit" type="form-row">
                <span class="ml-2" style="width: 40vw">{{ $t('totalPrice') }}</span>

                <span>{{ showCurrencyById(modelForm.currencyId, modelForm.pricePerUnit * modelForm.amount) }}</span>
            </Row>
            <Row v-if="!modelForm.isPayed" type="form-row">
                <span class="col-5" style="width: 40vw;">
                    {{ $t('payedAmount') }}
                </span>
                <span class="col-5 d-inline">
                    <input
                        class="col-9 form-control d-inline "
                        type="number"
                        v-model.number="modelForm.payedAmount"
                        :max="modelForm.pricePerUnit * modelForm.amount"
                        min="0"
                    />
                <span class="col-3 p-0 pl-2"> {{ showCurrencySymbolById(modelForm.currencyId) }} </span>
                </span>
            </Row>
            <CreditOrPayed :errors="errors" :model-form="modelForm"/>
            <SearchCollapse sm-size="10">
                <Row type="form-row" class="mt-3 pl-1">
                    <div class="col-7 col-sm-5 d-sm-inline p-0 pr-sm-1 pr-2">
                        <span>{{ $t('productPurchase.alertAmount') }} </span>
                        <input
                            class="form-control d-inline"
                            type="number"
                            min="0"
                            v-model="alertAmount"
                            @input="calculateAlertAmount()"
                        />
                    </div>
                    <div class="col-5 col-sm-5 d-sm-inline p-0 mr-0 pb-2 pb-sm-3">

                        <div class="mt-4 pt-2"
                             v-if="selectedProduct !== null && hasAdditionalUnitOfMeasure !== true"
                        >
                            {{ showUnitOfMeasure(selectedProduct.unitOfMeasure)}}
                        </div>
                        <span v-if="hasAdditionalUnitOfMeasure">
                        <span>{{ $t('unitOfMeasure.short') }}</span>
                        <v-select
                            :options="additionalUnitOfMeasure"
                            label="name"
                            :reduce="options => options.id"
                            v-model="modelForm.additionalUnitOfMeasure"
                            @input="calculateAlertAmount()"
                        >
                            <template>
                                {{ $t("selectError") }}
                            </template>
                        </v-select>
                    </span>

                    </div>
                </Row>
                <Row type="form-row" class="mb-5">
                    <InputBox
                        :inputFunction="expirationDate"
                        :model-form="modelForm"
                        model-name="shelfLife"
                        :no-margin-top="true"
                        :errors="errors"
                        title="product.expirationDate"
                        type="date"
                        xs-size="12"
                        sm-size="5">
                    </InputBox>
                    <Column xs-size="12" sm-size="5">
                        <b-form-checkbox
                            @input="makeExpirationDateNull"
                            v-model="hasExpirationDate"
                            class="pt-0 pl-20 pt-sm-3 mt-sm-4"
                            size="mg"
                        >
                            {{ $t('product.hasExpirationDate') }}
                        </b-form-checkbox>
                    </Column>
                </Row>
            </SearchCollapse>

            <SubmitRow
                :is-disabled="!modelForm.amount || !modelForm.pricePerUnit || !modelForm.warehouseId || !modelForm.product || !modelForm.bulkPrice"
                :is-loading="isLoading"
                :do-action="add"
            />

        </FormTag>
    </Row>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import validatorMixin from "../../mixin/validatorMixin";
import Amount from "../../components/Amount";
import PricePerUnit from "../../components/PricePerUnit";
import CreditOrPayed from "../../components/CreditOrPayed";
import SubmitRow from "../../components/SubmitRow";
import Row from "../../components/html/Row";
import BreadcrumbRow from "../../components/BreadcrumbRow";
import GoBackButtonRow from "../../components/GoBackButtonRow";
import FormTag from "../../components/html/FormTag";
import MarginTop from "../../components/html/MarginTop";
import Modal from "@/components/html/Modal";
import SelectBoxAndAddButton from "@/components/SelectBoxAndAddButton";
import '../../style/vue-select.css';
import vSelect from 'vue-select'
import Column from "@/components/html/Column";
import ButtonTag from "@/components/html/ButtonTag";
import TextTag from "@/components/html/TextTag";
import currencyFormatMixin from "../../mixin/currencyFormatMixin";
import InputBox from "@/components/InputBox";
import IconButton from "@/components/IconButton";
import sizeClassesMixin from "@/components/html/mixin/sizeClassesMixin";
import displayClassesMixin from "@/components/html/mixin/displayClassesMixin";
import SearchCollapse from "@/components/SearchCollapse";
import currencyRateMixin from "@/mixin/currencyRateMixin";


export default {
    name: "ProductPurchasesPurchase",
    mixins: [validatorMixin, currencyFormatMixin, sizeClassesMixin, displayClassesMixin, currencyRateMixin],
    computed: {
        ...mapGetters(['getWarehouses', 'getSuppliers', 'getProducts', 'getCurrencies', 'getCurrency']),
    },
    methods: {
        ...mapActions([
            'fetchSuppliers',
            'fetchProductsSearch',
            'fetchWarehousesSearch',
            'fetchProductsIsNotify',
            'fetchAllProductsInWarehouses'
        ]),
        changeInput() {
            if (this.hasAdditionalUnitOfMeasure) {
                if (this.quantityCalculation[0].unitOfMeasures.howMany !== 0) {
                    this.modelForm.pricePerUnit = parseInt(this.modelForm.bulkPrice) / parseInt(this.quantityCalculation[0].unitOfMeasures.howMany)
                }
            } else {
                this.modelForm.pricePerUnit = this.modelForm.bulkPrice
            }

        },
        unit() {
            if (this.hasAdditionalUnitOfMeasure) {
                return this.quantityCalculation[0].unitOfMeasures.name.toString()
            }

            if (this.selectedProduct !== null) {
                return this.showUnitOfMeasure(this.selectedProduct.unitOfMeasure)
            }

            return " "
        },
        moreAmount() {
            if (this.quantityCalculation.length + 1 <= this.additionalUnitOfMeasure.length) {
                this.quantityCalculation.push({
                    amountUnitOfMeasures: 1,
                    unitOfMeasures: {},
                })
                this.quantityCalculation[this.quantityCalculation.length - 1].unitOfMeasures = this.additionalUnitOfMeasure[this.quantityCalculation.length - 1]
            }
            this.calculateAmount();
        },
        deleteOne(index) {
            this.quantityCalculation.splice(index, 1)
            this.calculateAmount();
        },
        calculateAmount() {
            this.modelForm.amount = 0

            for (let amount of this.quantityCalculation) {
                if (amount.amountUnitOfMeasures !== '' && amount.unitOfMeasures !== null) {
                    this.modelForm.amount += amount.unitOfMeasures.howMany * amount.amountUnitOfMeasures
                }
            }

            this.changeInput()
        },
        calculateAlertAmount() {
            if (this.modelForm.additionalUnitOfMeasure !== null) {
                for (let unitOfMeasure of this.additionalUnitOfMeasure) {
                    if(this.modelForm.additionalUnitOfMeasure === unitOfMeasure.id) {
                        this.modelForm.alertAmount = this.alertAmount * unitOfMeasure.howMany
                    }
                }
            } else {
                this.modelForm.alertAmount = this.alertAmount
            }
        },
        selectFoundProduct() {
            if (this.isSearchByBarCode) {
                this.selectedProduct = this.foundProduct
                this.modelForm.product = this.selectedProduct
                this.isSearchByBarCode = false
            }

            this.productBarCode = null
        },
        inSelectedProduct() {
            if (!this.isSearchByBarCode) {
                this.productBarCode = ''
                this.modelForm.bulkPrice = ''
                this.modelForm.pricePerUnit = ''

                if (this.selectedProduct !== null) {
                    this.modelForm.product = this.selectedProduct

                    if (this.selectedProduct.barCode !== null) {
                        this.productBarCode = this.selectedProduct.barCode
                    }

                    if (this.selectedProduct.additionalUnitOfMeasures.length) {
                        this.calculationByUnitOfMeasure(this.selectedProduct)

                        this.quantityCalculation[0].unitOfMeasures = this.additionalUnitOfMeasure[0]
                        this.modelForm.amount = 0

                        this.calculateAmount();
                    }

                    if (this.selectedProduct.additionalUnitOfMeasures.length === 0) {
                        this.modelForm.amount = 1
                        this.quantityCalculation = [{amountUnitOfMeasures: 1, unitOfMeasures: {}}]
                        this.hasAdditionalUnitOfMeasure = false
                    }
                }
            }
        },
        calculationByUnitOfMeasure(product) {
            this.hasAdditionalUnitOfMeasure = true
            this.additionalUnitOfMeasure = []
            this.quantityCalculation = [{amountUnitOfMeasures: 1, unitOfMeasures: {}}]

            for (let unitOfMeasures of product.additionalUnitOfMeasures) {
                this.additionalUnitOfMeasure.push({
                    name: unitOfMeasures.unitOfMeasure,
                    howMany: unitOfMeasures.howMany,
                    id: unitOfMeasures.id
                })
            }

            this.additionalUnitOfMeasure.sort((a, b) => b.howMany - a.howMany)
            this.additionalUnitOfMeasure.push({
                name: product.unitOfMeasure,
                howMany: 1,
                id: null
            })

            this.changeValueUnitOfMeasure()
        },
        changeValueUnitOfMeasure() {
            for (let oneUnitOfMeasure of this.additionalUnitOfMeasure) {
                switch (oneUnitOfMeasure.name) {
                    case 'pc' :
                        oneUnitOfMeasure.name = this.$t("unitOfMeasure.pc")
                        break
                    case 'g' :
                        oneUnitOfMeasure.name = this.$t("unitOfMeasure.g")
                        break
                    case 'kg' :
                        oneUnitOfMeasure.name = this.$t("unitOfMeasure.kg")
                        break
                    case 'ml' :
                        oneUnitOfMeasure.name = this.$t("unitOfMeasure.ml")
                        break
                    case 'l' :
                        oneUnitOfMeasure.name = this.$t("unitOfMeasure.l")
                        break
                    case 'mm' :
                        oneUnitOfMeasure.name = this.$t("unitOfMeasure.mm")
                        break
                    case 'cm' :
                        oneUnitOfMeasure.name = this.$t("unitOfMeasure.cm")
                        break
                    case 'm' :
                        oneUnitOfMeasure.name = this.$t("unitOfMeasure.m")
                        break
                    case 'km' :
                        oneUnitOfMeasure.name = this.$t("unitOfMeasure.km")
                        break
                    case 'ft' :
                        oneUnitOfMeasure.name = this.$t("unitOfMeasure.ft")
                        break
                    case 'm3' :
                        oneUnitOfMeasure.name = this.$t("unitOfMeasure.m3")
                        break
                    default:
                        break
                }
            }
        },
        searchProductByBarCode() {
            this.modelForm.productId = null

            if (this.productBarCode.length === 13) {
                this.isSearchByBarCode = true
                let product = this.getProducts.find(product => this.productBarCode === product.barCode)

                if (product !== undefined) {
                    this.foundProduct = product
                }
            }
        },
        add() {
            this.isLoading = true

            if (this.modelForm.isPayed) {
                this.modelForm.payedAmount = this.modelForm.amount * this.modelForm.pricePerUnit
            } else {
                if (this.modelForm.payedAmount === '') {
                    this.modelForm.payedAmount = '0'
                }
            }

            this.calculateAlertAmount();

            this.modelForm.pricePerUnit = this.modelForm.pricePerUnit.toString()
            this.modelForm.payedAmount = this.modelForm.payedAmount.toString()
            this.modelForm.alertAmount = parseInt(this.modelForm.alertAmount)
            this.modelForm.productId = this.modelForm.product.id

            this.$store.dispatch('pushProductPurchase', this.modelForm)
                .then(() => {
                    this.isLoading = false
                    this.fetchProductsIsNotify()
                    this.$i18nHelper.toUrl('products/transactions')
                })
                .catch((reason) => {
                    this.isLoading = false
                    this.modalText = reason
                    this.$bvModal.show('modal_show')
                })
        },
        afterFetchWarehouse() {
            if (this.getWarehouses.length > 0) {
                this.modelForm.warehouseId = this.getWarehouses[0].id
            }
        },
        afterFetchSupplier(models) {
            if (models.length > 0) {
                this.modelForm.supplierId = models[0].id
            }

            for (let index in models) {
                let supplier = models[index];

                if (supplier.isCompany === undefined) {
                    supplier = models[index].value
                    models[index] = models[index].value
                }

                models[index].text = supplier.isCompany ?
                    supplier.supplierCompany.name :
                    supplier.person.givenName + ' ' + supplier.person.familyName
            }

            if (models.length > 0) {
                this.modelForm.supplierId = models[0].id
            }
        },
        expirationDate() {
            this.hasExpirationDate = false
        },
        makeExpirationDateNull() {
            if (this.hasExpirationDate) {
                this.modelForm.shelfLife = null
            }
        },
    },
    data() {
        return {
            alertAmount: null,
            hasAdditionalUnitOfMeasure: false,
            additionalUnitOfMeasure: [],
            selectedProduct: null,
            foundProduct: null,
            isSearchByBarCode: false,
            modalText: '',
            hasExpirationDate: true,
            isLoading: false,
            productBarCode: '',
            quantityCalculation: [{
                amountUnitOfMeasures: null,
                unitOfMeasures: {},
            }],
            errors: {
                productId: null,
                supplierId: null,
                warehouseId: null,
                currencyId: null,
                amount: null,
                pricePerUnit: null,
                shelfLife: null,
            },
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'product.title', url: 'products'},
                {name: "purchase"},
            ],
            modelForm: {
                product: null,
                warehouseId: null,
                currencyId: 0,
                supplierId: 0,
                amount: 1,
                pricePerUnit: '',
                bulkPrice: '',
                isPayed: true,
                test: null,
                payedAmount: '',
                shelfLife: null,
                alertAmount: null,
                additionalUnitOfMeasure: null,
            },

        }
    },
    mounted() {
        window.scrollTo(0, 0)

        this.fetchProductsSearch()
            .then(() => {
                this.afterFetchWarehouse()

                if (this.$route.params.id !== '0') {
                    this.modelForm.productId = parseInt(this.$route.params.id)
                }

                if (this.$route.params.productName !== '0') {
                    if (this.getProducts.length > 0) {
                        for(let product of this.getProducts) {
                            if(product.name === this.$route.params.productName) {
                                this.selectedProduct = product
                                this.modelForm.product = product
                            }
                        }
                    }
                }
            })
        this.fetchWarehousesSearch()
            .then(() => {
                if (this.$route.params.warehouseId) {
                    this.modelForm.warehouseId = parseInt(this.$route.params.warehouseId)
                }
            })
    },
    components: {
        IconButton,
        InputBox,
        TextTag,
        ButtonTag,
        Column,
        MarginTop,
        FormTag,
        GoBackButtonRow,
        BreadcrumbRow,
        Row,
        SubmitRow,
        CreditOrPayed,
        PricePerUnit,
        Amount,
        Modal,
        SelectBoxAndAddButton,
        vSelect,
        SearchCollapse,
    },
}
</script>
